// src/lib/outcomeDisplayLabels.js
// Ported from takso-poc/takso-reporting-ui/src/lib/outcomeDisplayLabels.js — do not rename.
//
// Chart display labels for the 22 Takso outcome measures.
// Used on chart X-axis annotations (OutcomeRatings) and outcome ladder labels.

const OUTCOME_X_LABELS = {
  //  id   Display label
  1: 'Creativity',
  2: 'Aesthetic enrichment',
  3: 'Knowledge, ideas and insight',
  4: 'Diversity of cultural expression',
  6: 'Wellbeing (physical and mental)',
  8: 'Feeling valued',
  9: 'Social connectedness',
  10: 'Employment skills',
  13: 'Support for local economy',
  17: 'Access to networks and resources',
  21: 'Valuing the natural world',
  22: 'Understanding of ecological issues',
  26: 'Bridging social differences',
};

// Fallback regex: strips trailing past participle for any outcome ID not in the map.
const PARTICIPLE_RE =
  /\s+(stimulated|experienced|gained|appreciated|improved|enhanced|bridged|strengthened|developed|increased|built|deepened|celebrated|acknowledged|supported|heightened|expressed|practiced|understood|connected|generated|promoted|formed|activated)$/i;

/**
 * Returns the concise chart display label for a Takso outcome.
 *
 * @param {string}        title  Raw sOutcome.title from the DB
 * @param {number|string} id     sOutcome.id
 * @returns {string}
 */
export function displayOutcome(title, id) {
  if (!title) return title;
  const lookup = OUTCOME_X_LABELS[Number(id)];
  if (lookup) return lookup;
  return title.replace(PARTICIPLE_RE, '').trim();
}
